export default "__VITE_ASSET__DmmVe5XF__"